import React from 'react';
import { useStore } from '../../../../store';
import { convertFilterToQueryString, getInitialTransactionsFilters } from '../../../transactions/utils';
import NewLatestTransactions from '../../../../generic-components/LatestTransactions/LatestTransactions';
import { useTaxBucketTransactionsQuery } from '../../../../hooks/query/useTaxBucketTransactionsQuery';

const TaxBucketLatestTransactions = () => {
  const PATH = '/tax-bucket-transactions';
  const { customerId } = useStore((state) => state.user);
  const query = convertFilterToQueryString(getInitialTransactionsFilters());
  const { data, isLoading } = useTaxBucketTransactionsQuery({ customerId, query });
  const transactionList = !isLoading && data ? data.transactionList.slice(0, 7) : [];
  return (
    <div className='border border-outline-primary-bw-03 rounded-[12px] bg-surface-primary-bw-00 shadow-widgetCard h-[577px]'>
      <NewLatestTransactions
        data={transactionList}
        isLoading={isLoading}
        navPath={PATH}
        showMore={data?.transactionList.length > 0}
      />
    </div>
  );
};

export default TaxBucketLatestTransactions;
